import { defineStore } from "pinia";
/** Lee la secuencia del pupilo (API usa `studend_*`; front puede tener `student_*`). */
export const leerSecuenciaApoderado = (apoderado) => {
    if (!apoderado)
        return undefined;
    const raw = apoderado.studend_userCourse_seq ?? apoderado.student_userCourse_seq;
    return raw == null || String(raw).trim() === ""
        ? undefined
        : String(raw).trim();
};
const normalizarSecuenciaApoderado = (apoderado) => {
    const raw = apoderado.student_userCourse_seq ?? apoderado.studend_userCourse_seq;
    const seq = raw == null || String(raw).trim() === ""
        ? undefined
        : String(raw).trim();
    return {
        ...apoderado,
        student_userCourse_seq: seq,
        studend_userCourse_seq: seq,
    };
};
export const useTesoreroStore = defineStore("tesorero", {
    state: () => ({
        apoderadoSeleccionado: null,
        cursoContext: null,
    }),
    getters: {
        secuenciaApoderadoSeleccionado() {
            return leerSecuenciaApoderado(this.apoderadoSeleccionado);
        },
    },
    actions: {
        setApoderadoSeleccionado(apoderado) {
            const normalizado = apoderado
                ? normalizarSecuenciaApoderado(apoderado)
                : null;
            this.apoderadoSeleccionado = normalizado;
            // Guardar en localStorage
            if (normalizado) {
                localStorage.setItem("tesorero_apoderado_seleccionado", JSON.stringify(normalizado));
            }
            else {
                localStorage.removeItem("tesorero_apoderado_seleccionado");
            }
        },
        setCursoContext(context) {
            this.cursoContext = context;
            // Guardar en localStorage
            if (context) {
                localStorage.setItem("tesorero_curso_context", JSON.stringify(context));
            }
            else {
                localStorage.removeItem("tesorero_curso_context");
            }
        },
        clearSeleccion() {
            this.apoderadoSeleccionado = null;
            localStorage.removeItem("tesorero_apoderado_seleccionado");
        },
        clearContext() {
            this.cursoContext = null;
            localStorage.removeItem("tesorero_curso_context");
        },
        clearAll() {
            this.clearSeleccion();
            this.clearContext();
        },
        // Cargar datos del localStorage al inicializar
        initializeFromStorage() {
            try {
                const apoderadoStored = localStorage.getItem("tesorero_apoderado_seleccionado");
                if (apoderadoStored) {
                    this.apoderadoSeleccionado = normalizarSecuenciaApoderado(JSON.parse(apoderadoStored));
                }
                const contextStored = localStorage.getItem("tesorero_curso_context");
                if (contextStored) {
                    this.cursoContext = JSON.parse(contextStored);
                }
            }
            catch (error) {
                console.error("Error al cargar datos del tesorero desde localStorage:", error);
                this.clearAll();
            }
        },
    },
});
// Función para inicializar el store
export const initializeTesoreroStore = () => {
    const store = useTesoreroStore();
    store.initializeFromStorage();
};
